/**
 * Gift Card Recipient Form JavaScript
 * Handles form toggle, validation, and character counting
 * 
 * IMPORTANT: Shopify requires these exact property names:
 * - "__shopify_send_gift_card_to_recipient" with value "true" (REQUIRED flag)
 * - "Recipient email" (required)
 * - "Recipient name" (optional)
 * - "Send on" (optional)
 * - "Message" (optional)
 */

(function() {
  'use strict';

  var RecipientForm = {
    init: function() {
      this.forms = document.querySelectorAll('[data-recipient-form]');
      if (!this.forms.length) return;

      this.forms.forEach(function(form) {
        RecipientForm.setupForm(form);
      });
    },

    setupForm: function(form) {
      var checkbox = form.querySelector('.recipient-form__checkbox');
      var fieldsContainer = form.querySelector('[data-recipient-fields]');
      var emailInput = form.querySelector('[data-recipient-email]');
      var nameInput = form.querySelector('[data-recipient-name]');
      var dateInput = form.querySelector('[data-recipient-date]');
      var messageInput = form.querySelector('[data-recipient-message]');
      var charCount = form.querySelector('[data-char-count]');

      if (!checkbox || !fieldsContainer) return;

      // Store all recipient inputs for easy access
      var allInputs = [emailInput, nameInput, dateInput, messageInput].filter(Boolean);
      var self = this;

      // Enable checkbox (was disabled by default in HTML)
      checkbox.disabled = false;

      // Set default date to today
      if (dateInput) {
        var today = new Date();
        var formattedDate = today.toISOString().split('T')[0];
        dateInput.value = formattedDate;
        dateInput.min = formattedDate;
      }

      // Toggle fields visibility and enabled state
      checkbox.addEventListener('change', function() {
        self.toggleFields(fieldsContainer, allInputs, checkbox.checked, emailInput);
      });

      // Character counter for textarea
      if (messageInput && charCount) {
        messageInput.addEventListener('input', function() {
          charCount.textContent = messageInput.value.length;
        });
      }

      // Form validation - use capture phase to run before other handlers
      var productForm = form.closest('form');
      if (productForm && !productForm.hasAttribute('data-recipient-validated')) {
        productForm.setAttribute('data-recipient-validated', 'true');
        productForm.addEventListener('submit', function(e) {
          if (checkbox.checked && emailInput) {
            if (!self.validateEmail(emailInput.value)) {
              e.preventDefault();
              e.stopImmediatePropagation();
              emailInput.classList.add('recipient-form__input--error');
              emailInput.focus();
              alert('Please enter a valid recipient email address.');
              return false;
            }
            emailInput.classList.remove('recipient-form__input--error');
          }
        }, true); // Use capture phase
      }

      // Clear error on input
      if (emailInput) {
        emailInput.addEventListener('input', function() {
          emailInput.classList.remove('recipient-form__input--error');
        });
      }

      // Initialize hidden and disabled state
      this.toggleFields(fieldsContainer, allInputs, checkbox.checked, emailInput);
    },

    toggleFields: function(container, inputs, isEnabled, emailInput) {
      if (isEnabled) {
        // Show and enable fields
        container.style.display = 'block';
        container.style.opacity = '1';
        
        inputs.forEach(function(input) {
          if (input) {
            input.disabled = false;
          }
        });

        if (emailInput) {
          emailInput.required = true;
        }
      } else {
        // Hide and disable fields
        container.style.display = 'none';
        container.style.opacity = '0';
        
        inputs.forEach(function(input) {
          if (input) {
            input.disabled = true;
          }
        });

        if (emailInput) {
          emailInput.required = false;
        }
      }
    },

    validateEmail: function(email) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      RecipientForm.init();
    });
  } else {
    RecipientForm.init();
  }

  // Export for external use
  window.RecipientForm = RecipientForm;
})();

